/* @ngInject */
function customerSegmentsService (ConnectorWebService, CONSTANTS, Utils) {
  const service = {
    getAllBusinessModelsWithTexts,
    getAllBusinessSegmentsWithTexts,
    getAllBusinessActivitiesWithTextsBySegment,
    getBusinessSegmentByBusinessActivity
  }
  return service

  function getAllBusinessModelsWithTexts () {
    return ConnectorWebService.get(CONSTANTS.URL_BUSINESS_MODELS)
  }

  function getAllBusinessSegmentsWithTexts () {
    return ConnectorWebService.get(CONSTANTS.URL_BUSINESS_SEGMENTS)
  }

  function getAllBusinessActivitiesWithTextsBySegment (segmentId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_BUSINESS_SEGMENTS_ID_ACTIVITIES, [segmentId])
    return ConnectorWebService.get(url)
  }

  function getBusinessSegmentByBusinessActivity (activityId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_BUSINESS_ACTIVITIES_ID_SEGMENT, [activityId])
    return ConnectorWebService.get(url)
  }
}

export { customerSegmentsService }
